module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-navigation-drawer', {
    attrs: {
      "fixed": "",
      "dark": "",
      "app": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [(_vm.brandReady) ? [(_vm.brand.id) ? _c('div', [_c('img', {
    staticClass: "pt-5 brand-logo-navigation",
    attrs: {
      "src": _vm.brand.ManyEmpresaImage[0].description_source,
      "alt": "Propiedades en 9 de julio"
    }
  })]) : _c('div', [_c('img', {
    staticClass: "pt-5 brand-logo-navigation ",
    attrs: {
      "src": require("./assets/logo.png"),
      "alt": "Propiedades en 9 de julio"
    }
  })])] : _vm._e()], 2), _vm._v(" "), _vm._l((_vm.menu), function(item, i) {
    return _c('v-list', {
      key: i
    }, [_c('v-list-tile', {
      attrs: {
        "router": "",
        "to": item.link
      },
      on: {
        "click": function($event) {
          _vm.drawer = false
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.title))])], 1)], 1), _vm._v(" "), _c('v-divider')], 1)
  }), _vm._v(" "), _c('v-list', [(!_vm.brand.id) ? [_c('v-list-tile', {
    attrs: {
      "href": "/admin/login/",
      "target": "_blank"
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Acceso Inmobiliarias")])], 1)], 1), _vm._v(" "), _c('v-divider')] : _vm._e()], 2)], 2), _vm._v(" "), (_vm.brandReady) ? _c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "app": ""
    }
  }, [_c('v-toolbar-side-icon', {
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [(!_vm.drawer) ? _c('v-toolbar-title', [(_vm.brand.id) ? [_c('img', {
    staticClass: "brand-logo",
    attrs: {
      "src": _vm.brand.ManyEmpresaImage[0].description_source,
      "alt": "Propiedades en 9 de julio"
    }
  })] : [_c('img', {
    staticClass: "brand-logo",
    attrs: {
      "src": require("./assets/logo.png"),
      "alt": "Propiedades en 9 de julio"
    }
  })]], 2) : _vm._e()], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _vm._l((_vm.menu), function(item, i) {
    return [_c('v-btn', {
      staticClass: "hidden-sm-and-down",
      attrs: {
        "router": "",
        "to": item.link,
        "small": "",
        "primary": "",
        "light": ""
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(item.title) + "\n\t\t\t")])]
  }), _vm._v(" "), _c('v-spacer')], 2) : _vm._e(), _vm._v(" "), _c('v-content', [_c('v-container', {
    attrs: {
      "fluid": "",
      "mt-3": ""
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), (_vm.brandReady) ? _c('v-footer', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [(_vm.brand.id) ? _c('span', [_vm._v("© 2017-" + _vm._s(_vm.currentYear) + " " + _vm._s(_vm.brand.description) + " ")]) : _c('span', [_vm._v("© 2017-" + _vm._s(_vm.currentYear) + " 9dejulio.com ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [(_vm.brand.id) ? _c('p', {
    staticClass: "text-xs-right"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "title": "internet solutions",
      "href": "https://boxdata.com.ar"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://boxdata.com.ar/ext/boxdata_gris.gif"
    }
  })])]) : _vm._e()])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-204d61d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Esqueleto.vue
// module id = 78
// module chunks = 1